const BIMONTHLY = 'BIMONTHLY';
const BIWEEKLY = 'BIWEEKLY';
const DAILY = 'DAILY';
const HOURLY = 'HOURLY';
const MONTHLY = 'MONTHLY';
const ONCE = 'ONCE';
const QUARTERLY = 'QUARTERLY';
const WEEKLY = 'WEEKLY';
const YEARLY = 'YEARLY';
const UNSPECIFIED = 'UNSPECIFIED';

export const FREQUENCY_TYPES = {
    BIMONTHLY,
    BIWEEKLY,
    DAILY,
    HOURLY,
    MONTHLY,
    ONCE,
    QUARTERLY,
    WEEKLY,
    YEARLY,
    UNSPECIFIED
};